import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { PAYMENT_METHODS_STATUSES, VEHICLE_STATUSES } from 'constants/index';
import { setTab, setExternalFilters } from 'services/salesHistorySlice/salesHistorySlice';
import BuyerDocsIcon from '../icons/all_docs.svg';
import VehicleLeftPanel from './VehicleLeftPanel';

const DocLinksRow = styled.div<{ $visible: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
`;

const DocLink = styled.a`
  font-size: 14px;
  font-weight: 700;
  color: #225a91;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const DocLinkRouter = styled(Link)`
  font-size: 14px;
  font-weight: 700;
  color: #225a91;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const SeeTitleButton = styled.button<{ $visible: boolean }>`
  width: 100%;
  margin-top: 8px;
  padding: 0;
  background: #566F8D;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  height: 44px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};

  &:hover {
    background: #004a7e;
  }
`;

interface VehicleGridCardProps {
  vehicle: any;
}

const VehicleGridCard = ({ vehicle }: VehicleGridCardProps) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleSeeTitleInfo = () => {
    dispatch(setExternalFilters({ filters: { vin: vehicle.vin }, tab: 'sold' }));
    dispatch(setTab('sold'));
  };

  const footer = (
    <>
      <DocLinksRow $visible={vehicle.status === VEHICLE_STATUSES.AWARDED}>
        <BuyerDocsIcon />
        <DocLinkRouter to={`/vehicles/${vehicle.id}/buyer-docs`}>Buyer Docs</DocLinkRouter>
        {vehicle.seller_report_of_sale && (
          <DocLink href={vehicle.seller_report_of_sale} target="_blank" rel="noopener noreferrer">
            Report of Sale
          </DocLink>
        )}
        {vehicle.payment_status === PAYMENT_METHODS_STATUSES.APPROVED && (
          <DocLink href={`/vehicles/${vehicle.id}/funding-notice`} target="_blank" rel="noopener noreferrer">
            Funding Notice
          </DocLink>
        )}
      </DocLinksRow>
      <SeeTitleButton $visible={vehicle.status === VEHICLE_STATUSES.AWARDED} onClick={handleSeeTitleInfo}>SEE TITLE INFO</SeeTitleButton>
    </>
  );

  return (
    <VehicleLeftPanel
      vehicle={vehicle}
      onImageClick={() => history.push(`/vehicles/${vehicle.id}/view`)}
      showAwarded={vehicle.status === 'awarded'}
      panelWidth="100%"
      panelBackground="#fff"
      footer={footer}
    />
  );
};

export default VehicleGridCard;
